import React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../../misc/Dialog";
import { X } from "lucide-react";
import { Button } from "../../misc/Button";
import PostGraphicPicker from "./PostGraphicPicker";

interface PostGraphicPickerDialogProps {
  open: boolean;
  onClose: () => void;
  onSave?: () => void;
  isMobile: boolean;
  generalInstructions: string | string[];
  bgColor: { type: "solid" | "gradient"; color?: string; from?: string; to?: string; direction?: string };
  textColor: string;
  fontSize?: number;
  fontFamily?: string;
  setBgColor: React.Dispatch<React.SetStateAction<{ type: "solid" | "gradient"; color?: string; from?: string; to?: string; direction?: string }>>;
  setTextColor: React.Dispatch<React.SetStateAction<string>>;
  setFontSize?: React.Dispatch<React.SetStateAction<number>>;
  setFontFamily?: React.Dispatch<React.SetStateAction<string>>;
}

const PostGraphicPickerDialog: React.FC<PostGraphicPickerDialogProps> = ({
  open,
  onClose,
  onSave,
  isMobile,
  generalInstructions,
  bgColor,
  textColor,
  fontSize = 24,
  fontFamily = "Roboto",
  setBgColor,
  setTextColor,
  setFontSize = () => {},
  setFontFamily = () => {},
}) => (
  <Dialog open={open} onOpenChange={onClose}>
    <DialogContent className="max-w-4xl max-h-[90vh] overflow-hidden flex flex-col">
      <DialogHeader className="flex flex-row items-center justify-between">
        <DialogTitle>Edit Post Graphics</DialogTitle>
        <button
          onClick={onClose}
          className="rounded-sm opacity-70 ring-offset-background transition-opacity hover:opacity-100 focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2"
        >
          <X className="h-4 w-4" />
          <span className="sr-only">Close</span>
        </button>
      </DialogHeader>
      <div className="flex-1 overflow-y-auto">
        <PostGraphicPicker
          isOpen={open}
          onClose={onClose}
          isMobile={isMobile}
          generalInstructions={generalInstructions}
          bgColor={bgColor}
          textColor={textColor}
          fontSize={fontSize}
          fontFamily={fontFamily}
          setBgColor={setBgColor}
          setTextColor={setTextColor}
          setFontSize={setFontSize}
          setFontFamily={setFontFamily}
        />
      </div>
      <div className="flex justify-end pt-4 border-t">
        <Button
          onClick={() => {
            onSave?.();
            onClose();
          }}
          className="bg-primary text-primary-foreground hover:bg-primary/90"
        >
          Save
        </Button>
      </div>
    </DialogContent>
  </Dialog>
);

export default PostGraphicPickerDialog;